<template>
  <div v-show="getShowProjectModal" class="modal modal-project-container is-active" :class="{'slide-in-fwd-center-s1': currentState === 'project'}">
    <div class="modal-background" :class="{'faded': currentState !== 'project'}"></div>
      <div class="modal-content">
        <div class="modal-box">
          <div class="columns">
            <div class="column project">
              <div class="columns is-multiline">
                <div class="column is-12 modal-box-title">
                  <h2 v-if="!loadedProject && currentState === 'project'">{{$t('modal-project.modalProjectTitle')}}</h2>
                  <h2 v-else><span v-if="currentState === 'project'">{{$t('modal-project.modalLoadedProjectTitle')}}</span></h2>
                  <h2 v-if="currentState !== 'project'"><span>{{getProject.name}}</span></h2>
                </div>
                <div class="column is-12">
                  <div class="flex-center">
                    <form v-if="!loadedProject" enctype="multipart/form-data" novalidate>
                        <div class="dropbox flex-center">
                            <input type="file" :name="uploadProject" :title="$t('modal-project.modalUploadTitle')" accept=".nsdg" @change="filesChange($event, $event.target.files)" class="input-file">
                            <icon class="medium-svg fill-primary" name="cloud-upload"></icon>
                            <span>{{$t('modal-project.modalUploadLabel')}}</span>
                        </div>
                    </form>
                    <div v-else class="flex-direction-column modal-loaded-project" style="margin-top: 45px;">
                      <!-- <span v-if="getProject.name && currentState === 'project'" class="semi-bold">{{$t("modal-project.modalLoadedProjectName")}}</span><span v-if="getProject.name && currentState === 'project'" style="margin-bottom: 20px;">{{getProject.name}}</span> -->
                      <span v-if="getProject.dateCreated" class="semi-bold">{{$t("modal-project.modalLoadedProjectCreated")}}</span><span v-if="getProject.dateCreated" style="margin-bottom: 20px;">{{convertDate(getProject.dateCreated)}}</span>
                      <span v-if="getProject.lastSaved" class="semi-bold">{{$t("modal-project.modalLoadedProjectLastSaved")}}</span><span v-if="getProject.lastSaved" style="margin-bottom: 20px;">{{convertDate(getProject.lastSaved)}}</span>
                      <span class="semi-bold">{{$t("modal-project.modalLoadedProjectGlobalGoals")}}</span><span style="margin-bottom: 20px;">{{getProject.scenarios[0].goals.filter(goal => goal.selected || goal.selected === undefined).length}}</span>
                    </div>
                  </div>
                </div>
                <div class="column is-12 flex-center">
                  <button v-if="loadedProject && currentState === 'project'" @click="clearProject" class="button cancel-button">{{$t("modal-project.modalLoadedProjectCancel")}}</button>
                </div>
              </div>
              <div class="dropbox-wheel-background">
                <icon class="logo-svg" name="sdg-wheel-black"></icon>
              </div>
            </div>
            <div class="column new-project">
              <div class="columns is-multiline">
                <div class="column is-12 modal-box-title">
                  <h2 v-if="!loadedProject">{{$t('modal-project.modalNewProjectTitle')}}</h2>
                  <h2 v-else>{{$t('modal-project.modalLoadedProjectInfo')}}</h2>
                </div>
                <div class="column is-12">
                  <div class="control">
                    <div class="field">
                      <label class="label">{{$t('modal-project.modalAuthorName')}}</label>
                      <div class="control">
                        <input class="input" v-model="project.author" type="text" :placeholder="$t('modal-project.modalAuthorNamePlaceholder')" autofocus>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">{{$t('modal-project.modalNewProjectName')}}</label>
                      <div class="control">
                        <input class="input" v-model="project.name" type="text" :placeholder="$t('modal-project.modalNewProjectNameplaceholder')" autofocus>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">{{$t('modal-project.modalNewProjectDescription')}}</label>
                      <div class="control">
                        <textarea class="textarea" v-model="project.description" :placeholder="$t('modal-project.modalNewProjectDescriptionPlaceholder')"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-12 flex-center">
                  <div class="modal-sdg-wheel-circle">
                    <wheel :useComponentButton="showHowButton" @saveProject="saveProject" :view="currentState" :class="[getWheelVisible ? 'opacity-full': 'opacity-none']" ref="modalWheel" :name="'project'"></wheel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import wheel from './../sdg-wheel/sdg-wheel.vue'

export default {
  name: 'modal-project',
  components: {
    wheel
  },
  data () {
    return {
      uploadProject: 'file',
      loadedProject: false,
      project: {
        author: null,
        name: null,
        description: null,
        language: null
      }
    }
  },
  props: {
    currentState: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      getProject: 'getProject',
      getWheelVisible: 'getWheelVisible',
      getShowProjectModal: 'getShowProjectModal',
      getLanguage: 'getLanguage'
    }),
    showHowButton () {
      let mode = null
      if (this.currentState === 'project') {
        mode = 'load'
      } else if (this.getShowProjectModal && this.getWheelVisible && this.currentState !== 'project') {
        mode = 'edit'
      } else {
        return null
      }

      return mode
    }
  },
  watch: {
    currentState (val, oldVal) {
      if (val !== oldVal) {
        this.project.author = this.getProject.author || null
        this.project.name = this.getProject.name || null
        this.project.description = this.getProject.description || null
        this.project.language = this.getProject.language || null
      }
    },
    getShowProjectModal (val) {
      if (val && this.currentState !== 'project') {
        this.loadedProject = true
      }
    }
  },
  methods: {
    ...mapActions({
      setProject: 'setProject',
      setGoalList: 'setGoalList',
      setModalWheel: 'setModalWheel',
      setShowProjectModal: 'setShowProjectModal',
      setClearProject: 'setClearProject',
      setLanguage: 'setLanguage'
    }),
    setClass () {
      if (this.getShowProjectModal) {
        if (this.currentState === 'project') {
          return 'slide-in-fwd-center-s1'
        } else if (this.currentState !== 'project') {
          return 'slide-in-fwd-center'
        }
      } else {
        return 'fade-out'
      }
    },
    clearProject () {
      this.setClearProject()
      this.loadedProject = false
      this.project.author = null
      this.project.name = null
      this.project.description = null
      this.project.language = null
    },
    filesChange (fieldName, fileList) {
      const file = fileList[0]
      const reader = new FileReader()
      let _this = this
      reader.onload = function (event) {
        _this.project = JSON.parse(event.target.result)
        // _this.saveProject()
        _this.loadedProject = true
        _this.setProject(_this.project)
        _this.setI18n(_this.project.language)
      }
      reader.readAsText(file)
    },
    saveProject () {
      if (!this.project.name) {
        this.project.name = this.$t('top-bar.defaultProjectName')
      }
      if (!this.project.language && localStorage.userCachedLanguage) {
        this.project.language = localStorage.userCachedLanguage
      }

      this.setProject(this.project)
      this.setLanguage(this.project.language)
      this.setGoalList()
      this.setShowProjectModal(false)
      this.$emit('goTo')
    },
    setI18n (locale) {
      this.$i18n.locale = locale
    },
    convertDate (date) {
      if (this.project.language === 'da') {
        let convertDate = new Date(date).toLocaleString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' })
        let convertTime = new Date(date).toLocaleString('da-DK', { hour: 'numeric', minute: 'numeric' })
        return convertDate + ' Kl. ' + convertTime
      } else if (this.project.language === 'en') {
        let convertDate = new Date(date).toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
        let convertTime = new Date(date).toLocaleString('en-GB', { hour: 'numeric', minute: 'numeric' })
        return convertDate + ' - ' + convertTime
      } else if (this.project.language === 'fr') {
        let convertDate = new Date(date).toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
        let convertTime = new Date(date).toLocaleString('fr-FR', { hour: 'numeric', minute: 'numeric' })
        return convertDate + ' à ' + convertTime
      }
    }
  },
  created () {
    this.project.author = this.getProject.author || null
    this.project.name = this.getProject.name || null
    this.project.description = this.getProject.description || null
    this.project.language = this.getProject.language || null
  }
}
</script>
